import { styled } from '@mui/material';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';

interface StyledTimeTableCellProps extends WeekView.TimeTableCellProps {
  isDraftInWorkSchedule: boolean;
  isWorkScheduleOverlapping: boolean;
}

const StyledTimeTableCell = styled(WeekView.TimeTableCell, {
  shouldForwardProp: (prop) =>
    prop !== 'isDraftInWorkSchedule' && prop !== 'isWorkScheduleOverlapping',
})<StyledTimeTableCellProps>(
  ({ theme, isDraftInWorkSchedule, isWorkScheduleOverlapping }) => ({
    height: '5rem',
    cursor: isDraftInWorkSchedule ? 'default' : 'pointer',
    background: isWorkScheduleOverlapping
      ? theme.palette.common.white
      : theme.palette.gradients.grayDiagonalStripes,
    backgroundSize: '1.5rem 1.5rem',
    position: 'relative',
    '&:hover .MuiPaper-root': {
      opacity: 1,
    },
    '&:hover.MuiTableCell-root.Cell-cell': {
      backgroundColor: theme.palette.common.white,
    },
  }),
);

export default StyledTimeTableCell;
